import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

declare global {
  interface Window {
    Pusher: typeof Pusher
  }
}

window.Pusher = Pusher

const appKey = import.meta.env.VITE_PUSHER_APP_KEY
const wsHost = import.meta.env.VITE_PUSHER_HOST
const wsPort = Number(import.meta.env.VITE_PUSHER_PORT || 6001)
const forceTLS = (import.meta.env.VITE_PUSHER_SCHEME || 'http') === 'https'

const echo = new Echo({
  broadcaster: 'pusher',
  key: appKey,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1',
  wsHost,
  wsPort,
  wssPort: wsPort,
  forceTLS,
  enabledTransports: ['ws', 'wss'],
  authEndpoint: `${import.meta.env.VITE_APP_API_BASEURL}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
      Accept: 'application/json',
    },
  },
})

export function syncEchoAuthToken(token = localStorage.getItem('token') || '') {
  const authorization = `Bearer ${token}`
  const authHeaders = (echo.options.auth?.headers ?? {}) as Record<string, string>
  authHeaders.Authorization = authorization
  authHeaders.Accept = authHeaders.Accept || 'application/json'
  if (!echo.options.auth) {
    echo.options.auth = { headers: authHeaders }
  }
  else {
    echo.options.auth.headers = authHeaders
  }

  const connector = echo.connector as any
  if (connector?.pusher?.config?.auth?.headers) {
    connector.pusher.config.auth.headers.Authorization = authorization
    connector.pusher.config.auth.headers.Accept = connector.pusher.config.auth.headers.Accept || 'application/json'
  }
}

export function reconnectEcho(token = localStorage.getItem('token') || '') {
  syncEchoAuthToken(token)
  echo.disconnect()
  echo.connect()
}

export default echo
